import React, { useState } from "react";
import CircularProgress from "@mui/material/CircularProgress";
import { useSelector } from "react-redux";

import CardSection from "../../../components/CardSection/CardSection";
import { selectActiveUid } from "../../Auth/authSlice";
import {
  getKinshasaDateTime,
  getKinshasaDate,
} from "../../../utils/getKinshasaDateTime";
import { db } from "../../../config/firebaseConfig";
import { doc, setDoc } from "firebase/firestore";
import MyRetraitArgent from "../../../components/CardSection/MyRetraitArgent";

// Module-level static currency list to keep referential identity
const LIST_RETRAIT = [
  { value: "RETRAIT_CDF", label: "RETRAIT_CDF" },
  { value: "RETRAIT_USD", label: "RETRAIT_USD" },
  { value: "REMB_CDF", label: "REMB_CDF" },
  { value: "REMB_USD", label: "REMB_USD" },
];

const RetRembArgent = () => {
  const activeUid = useSelector(selectActiveUid);

  const [selectedRetRemb, setSelectedRetRemb] = useState("");
  const [retRembValue, setRetRembValue] = useState("");
  const [commentValue, setCommentValue] = useState("");
  const [cardOpen, setCardOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const listRetrait = LIST_RETRAIT;

  const handleSelectedRetraitChange = (e) => {
    const v = e?.target?.value ?? e;
    setSelectedRetRemb(v);
  };

  const handleChangeRetrait = (e) => {
    const v = e?.target?.value ?? e;
    setRetRembValue(v);
  };

  const handleChangeComment = (e) => {
    setCommentValue(e?.target?.value ?? "");
  };

  const handleSend = async () => {
    if (!selectedRetRemb || !retRembValue || !commentValue) return;
    setLoading(true);
    const date = getKinshasaDate();
    const uid = activeUid;
    if (!uid) {
      setLoading(false);
      return console.error("No authenticated user");
    }
    const stamp = getKinshasaDateTime();

    try {
      const docRef = doc(db, "users", uid, "data", date);
      const stampTime = stamp.split(" ")[1] || "00_00_00"; // Extract HH:MM:SS and replace : with _
      const timeKey = stampTime.replace(/:/g, "_");
      const prefix = selectedRetRemb.includes("REMB_")
        ? "REMB_ARGENT"
        : "RETRAIT_ARGENT";
      const key = `${prefix}_${timeKey}`;

      await setDoc(
        docRef,
        {
          [key]: {
            item: selectedRetRemb,
            value: retRembValue,
            comment: commentValue,
            type: prefix,
            date: stamp,
          },
        },
        { merge: true }
      );

      setSelectedRetRemb("");
      setRetRembValue("");
      setCommentValue("");
      setCardOpen(false); // Close after Firestore write
    } catch (e) {
      console.error("Error sending: ", e);
    }
    setLoading(false);
  };

  return loading ? (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        marginTop: 32,
      }}
    >
      <CircularProgress color="primary" size={48} />
      <div style={{ marginTop: 16, fontSize: 18 }}>Chargement...</div>
    </div>
  ) : (
    <CardSection
      title="RETRAIT ET REMB. ARGENT"
      showDefaultControls={false}
      open={cardOpen}
      setOpen={setCardOpen}
    >
      <MyRetraitArgent
        listItem={listRetrait}
        selectedItem={selectedRetRemb}
        onSelectedItemChange={handleSelectedRetraitChange}
        amount={retRembValue}
        onAmountChange={handleChangeRetrait}
        textValue={commentValue}
        onTextChange={handleChangeComment}
        onSend={handleSend}
      />
    </CardSection>
  );
};

export default RetRembArgent;
